import { Component, Story, Knobs, Accents, Icons, IconAccents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  heading: {
    default: 'Modal title',
    editor: 'textbox',
  },
  borderAccent: {
    default: 'viridiangreen',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  headerOption1: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Icons),
  },
  headerOption1Text: {
    default: '',
    editor: 'textbox',
  },
  headerOption1Accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  headerOption1RoundedBackground: {
    default: false,
    editor: 'checkbox',
  },
  headerOption1RoundedBackgroundAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  headerOption1Disabled: {
    default: false,
    editor: 'checkbox',
  },
  width: {
    default: 'small',
    editor: 'dropdown',
    editorOptions: ['small', 'medium', 'large', 'full-screen'],
  },
  primaryButton: {
    default: 'Okay',
    editor: 'textbox',
  },
  primaryButtonAccent: {
    default: 'viridiangreen',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  primaryButtonIcon: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Icons),
  },
  primaryButtonIconAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(IconAccents),
  },
  cancelButton: {
    default: 'Cancel',
    editor: 'textbox',
  },
  cancelButtonIcon: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Icons),
  },
  cancelButtonIconAccent: {
    default: 'title',
    editor: 'dropdown',
    editorOptions: [''].concat(IconAccents),
  },
  suppressCloseIcon: {
    default: false,
    editor: 'checkbox',
  },
};
const playgroundStory: Story = {
  title: 'Playground',
  description: 'A tag-modal where you can change all the attributes',
  coreComponent: {
    html: `<tag-modal visible {{...knobs}}>
  <div>You can put any content you like here</div>
</tag-modal>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper: {
    jsx: `<TagModal visible {{...knobs}}
>
  <div>You can put any content you like here</div>
</TagModal>`,
    knobs: PlaygroundKnobs,
  },
};

const buttonsStory: Story = {
  title: 'Buttons',
  description: 'A tag-modal with a primary and cancel buttons',
  coreComponent: {
    html: `<tag-modal
  visible
  heading='Modal with buttons'
  primary-button='Okay'
  primary-button-icon='Tick'
  primary-button-accent='midnightblue'
  cancel-button='Cancel'
  cancel-button-icon='Cross'
  cancel-button-icon-accent='title'>
  <div>You can put any content you like here</div>
</tag-modal>`,
  },
  reactWrapper: {
    jsx: `<TagModal
  visible
  heading='Modal with buttons'
  primaryButton='Okay'
  primaryButtonIcon='Tick'
  primaryButtonAccent='midnightblue'
  cancelButton='Cancel'
  cancelButtonIcon='Cross'
  cancelButtonIconAccent='title'>
  <div>You can put any content you like here</div>
</TagModal>`,
  },
};

const customButtonStylesStoryKnobs: Knobs = {
  primaryButtonStyle: {
    default: '{"min-width":"200px", "height": "50px"}',
    editor: 'multilinetextbox',
  },
  cancelButtonStyle: {
    default: '{"min-width":"150px", "height": "50px"}',
    editor: 'multilinetextbox',
  },
};
const customButtonStylesStory: Story = {
  title: 'Custom button styles',
  description: 'A tag-modal with a primary and cancel buttons that have custom styles',
  coreComponent: {
    html: `<tag-modal
  visible
  heading='Modal with buttons'
  primary-button='Okay'
  primary-button-accent='midnightblue'
  {{primaryButtonStyle}}
  cancel-button='Cancel'
  {{cancelButtonStyle}}>
  <div>You can put any content you like here</div>
</tag-modal>`,
    knobs: customButtonStylesStoryKnobs,
  },
  reactWrapper: {
    jsx: `<TagModal
  visible
  heading='Modal with buttons'
  primaryButton='Okay'
  primaryButtonAccent='midnightblue'
  {{primaryButtonStyle}}
  cancelButton='Cancel'
  {{cancelButtonStyle}}>
  <div>You can put any content you like here</div>
</TagModal>`,
    knobs: {
      primaryButtonStyle: {
        default: '{ minWidth:"200px", height: "50px"}',
        editor: 'multilinetextbox',
        qualifierStart: '{',
        qualifierEnd: '}',
      },
      cancelButtonStyle: {
        default: '{ minWidth:"150px", height: "50px"}',
        editor: 'multilinetextbox',
        qualifierStart: '{',
        qualifierEnd: '}',
      },
    },
  },
};

const openCloseStory: Story = {
  title: 'Open and close',
  description: 'A tag-modal that is programmatically opened and closed',
  coreComponent: {
    html: `<tag-modal
  heading='Modal that is programmatically opened and closed'>
  <div>
    <tag-button text='Click me to close this modal'><tag-button>
  </div>
</tag-modal>
<tag-button text='Open'><tag-button>`,
    js: `var openButton = document.querySelector("tag-button[text='Open']");
var closeButton = document.querySelector("tag-button[text='Click me to close this modal']");
var modal = document.querySelector("tag-modal");
openButton.addEventListener("buttonClick", function () {
  modal.show();
});
closeButton.addEventListener("buttonClick", function () {
  modal.hide();
});`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [visible, setVisible] = React.useState(false);

    return (
      <React.Fragment>
        <TagModal
          heading='Modal that is programmatically opened and closed'
          visible={visible}
        >
          <div>
            <TagButton
              text='Click me to close this modal'
              onButtonClick={() => setVisible(false)}
            />
          </div>
        </TagModal>
        <TagButton
          text='Open'
          onButtonClick={() => setVisible(true)}
        />
      </React.Fragment>
    );
  }`,
  },
};

const roundedheaderOptionsStory: Story = {
  title: 'Rounded header options',
  description: 'A tag-modal with round options in the header',
  coreComponent: {
    html: `<tag-modal
  visible
  heading='Modal with header options'
  header-option-1='Arrow2Left'
  header-option-1-accent='porcelain'
  header-option-1-rounded-background
  header-option-1-rounded-background-accent='navy'
  header-option-2='Arrow2Right'
  header-option-2-accent='porcelain'
  header-option-2-rounded-background
  header-option-2-rounded-background-accent='navy'
  header-option-3='Settings'
  header-option-3-accent='porcelain'
  header-option-3-rounded-background
  header-option-3-rounded-background-accent='navy'
  primary-button='OK'
  cancel-button='Cancel'>
  <div>You can put any content you like here</div>
</tag-modal>`,
  },
  reactWrapper: {
    jsx: `<TagModal
  visible
  heading='Modal with header options'
  headerOption1='Arrow2Left'
  headerOption1Accent='porcelain'
  headerOption1RoundedBackground
  headerOption1RoundedBackgroundAccent='navy'
  headerOption2='Arrow2Right'
  headerOption2Accent='porcelain'
  headerOption2RoundedBackground
  headerOption2RoundedBackgroundAccent='navy'
  headerOption3='Settings'
  headerOption3Accent='porcelain'
  headerOption3RoundedBackground
  headerOption3RoundedBackgroundAccent='navy'
  primaryButton='OK'
  cancelButton='Cancel'>
  <div>You can put any content you like here</div>
</TagModal>`,
  },
};

const oldSchoolheaderOptionsStory: Story = {
  title: 'Old school header options',
  description: 'A tag-modal with old school style options in the header',
  coreComponent: {
    html: `<tag-modal
  visible
  heading='Modal with header options'
  header-option-1='Arrow2Left'
  header-option-1-text='Back'
  header-option-2='Arrow2Right'
  header-option-2-text='Forward'
  header-option-3='Settings'
  header-option-3-text='Settings'
  primary-button='OK'
  cancel-button='Cancel'>
  <div>You can put any content you like here</div>
</tag-modal>`,
  },
  reactWrapper: {
    jsx: `<TagModal
  visible
  heading='Modal with header options'
  headerOption1='Arrow2Left'
  headerOption1Text='Back'
  headerOption2='Arrow2Right'
  headerOption2Text='Forward'
  headerOption3='Settings'
  headerOption3Text='Settings'
  primaryButton='OK'
  cancelButton='Cancel'>
  <div>You can put any content you like here</div>
</TagModal>`,
  },
};

const alertStory: Story = {
  title: 'Alert',
  description: 'A tag-modal with alert appearing',
  coreComponent: {
    html: `<tag-modal
  visible
  heading="A tag-modal with alert appearing">
  <div>
    <tag-button text="Show alert"></tag-button>
  </div>
</tag-modal>
<tag-toast position='bottom-left'>
  <tag-alert
    visible="false"
    type='information'
    alert-type='toast'
    text='Some useful information'
    closeable>
  </tag-alert>
</tag-toast>`,
    js: `var modal = document.querySelector('tag-modal');
var alert = document.querySelector('tag-alert');
var showAlertButton = document.querySelector('tag-button[text="Show alert"]');
showAlertButton.addEventListener("buttonClick", function () {
  alert.show();
});`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [alertVisible, setAlertVisible] = React.useState(false);
    return (
      <React.Fragment>
        <TagModal
          visible
          heading="A tag-modal with alert appearing">
          <div>
            <TagButton
              text="Show alert"
              onButtonClick={() => setAlertVisible(true)}
            />
          </div>
        </TagModal>
        <TagToast position='bottom-left'>
          <TagAlert
            visible={alertVisible}
            type='information'
            alertType='toast'
            text='Some useful information'
            closeable>
          </TagAlert>
        </TagToast>
      </React.Fragment>
    )
    };`,
  },
};

const focusStory: Story = {
  title: 'Focus',
  description: 'A tag-modal with focus on a search box inside it',
  coreComponent: {
    html: `<tag-modal
  visible
  heading='tag-modal with focus on a search box'>
  <div>
    <tag-searchbox placeholder='Search for records...'></tag-searchbox>
  </div>
</tag-modal>`,
    js: `var modal = document.querySelector('tag-modal');
modal.addEventListener('opened', function() {
  var searchBox = document.querySelector('tag-searchbox');
  searchBox.focusEditor();
});`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const searchBox = React.useRef(null);
  return (
    <TagModal
      visible
      heading='tag-modal with focus on a search box'
      onOpened={() => {
        searchBox.current.tagComponent.current.focusEditor();
      }}
    >
      <div>
        <TagSearchbox ref={searchBox} placeholder='Search for records...' />
      </div>
    </TagModal>
  )
  };`,
  },
};

const fixedHeightStory: Story = {
  title: 'Fixed height',
  description: 'A tag-modal with fixed height',
  coreComponent: {
    html: `<tag-modal
  visible
  heading='Modal with fixed height'
  content-style='{"overflow": "scroll", "height":"200px"}'>
  <div>
    <tag-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin volutpat aliquet venenatis. Sed faucibus maximus volutpat. Praesent fermentum porta urna, sed ornare justo facilisis eu. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Proin congue enim tortor, in aliquam ipsum hendrerit a. Suspendisse iaculis dui pellentesque ante accumsan posuere. Curabitur vulputate mollis libero quis ullamcorper. Maecenas nec massa id nisi interdum lobortis. Donec tempus libero in magna tincidunt, in iaculis nisl vehicula. Proin vel odio dolor. Sed in gravida est. Mauris ut nibh eget arcu iaculis ultricies id ac ante. Integer dapibus, ipsum at pulvinar placerat, elit erat mattis lacus, ac tempus ipsum massa eget lectus. Maecenas commodo, nisi eu commodo cursus, elit magna congue tellus, sed pellentesque ligula dolor at quam. Ut id dui lacus. Suspendisse consequat est nec nibh vehicula, vel volutpat mauris accumsan.</tag-text>
    <tag-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin volutpat aliquet venenatis. Sed faucibus maximus volutpat. Praesent fermentum porta urna, sed ornare justo facilisis eu. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Proin congue enim tortor, in aliquam ipsum hendrerit a. Suspendisse iaculis dui pellentesque ante accumsan posuere. Curabitur vulputate mollis libero quis ullamcorper. Maecenas nec massa id nisi interdum lobortis. Donec tempus libero in magna tincidunt, in iaculis nisl vehicula. Proin vel odio dolor. Sed in gravida est. Mauris ut nibh eget arcu iaculis ultricies id ac ante. Integer dapibus, ipsum at pulvinar placerat, elit erat mattis lacus, ac tempus ipsum massa eget lectus. Maecenas commodo, nisi eu commodo cursus, elit magna congue tellus, sed pellentesque ligula dolor at quam. Ut id dui lacus. Suspendisse consequat est nec nibh vehicula, vel volutpat mauris accumsan.</tag-text>
    <tag-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin volutpat aliquet venenatis. Sed faucibus maximus volutpat. Praesent fermentum porta urna, sed ornare justo facilisis eu. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Proin congue enim tortor, in aliquam ipsum hendrerit a. Suspendisse iaculis dui pellentesque ante accumsan posuere. Curabitur vulputate mollis libero quis ullamcorper. Maecenas nec massa id nisi interdum lobortis. Donec tempus libero in magna tincidunt, in iaculis nisl vehicula. Proin vel odio dolor. Sed in gravida est. Mauris ut nibh eget arcu iaculis ultricies id ac ante. Integer dapibus, ipsum at pulvinar placerat, elit erat mattis lacus, ac tempus ipsum massa eget lectus. Maecenas commodo, nisi eu commodo cursus, elit magna congue tellus, sed pellentesque ligula dolor at quam. Ut id dui lacus. Suspendisse consequat est nec nibh vehicula, vel volutpat mauris accumsan.</tag-text>
    <tag-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin volutpat aliquet venenatis. Sed faucibus maximus volutpat. Praesent fermentum porta urna, sed ornare justo facilisis eu. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Proin congue enim tortor, in aliquam ipsum hendrerit a. Suspendisse iaculis dui pellentesque ante accumsan posuere. Curabitur vulputate mollis libero quis ullamcorper. Maecenas nec massa id nisi interdum lobortis. Donec tempus libero in magna tincidunt, in iaculis nisl vehicula. Proin vel odio dolor. Sed in gravida est. Mauris ut nibh eget arcu iaculis ultricies id ac ante. Integer dapibus, ipsum at pulvinar placerat, elit erat mattis lacus, ac tempus ipsum massa eget lectus. Maecenas commodo, nisi eu commodo cursus, elit magna congue tellus, sed pellentesque ligula dolor at quam. Ut id dui lacus. Suspendisse consequat est nec nibh vehicula, vel volutpat mauris accumsan.</tag-text>
    <tag-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin volutpat aliquet venenatis. Sed faucibus maximus volutpat. Praesent fermentum porta urna, sed ornare justo facilisis eu. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Proin congue enim tortor, in aliquam ipsum hendrerit a. Suspendisse iaculis dui pellentesque ante accumsan posuere. Curabitur vulputate mollis libero quis ullamcorper. Maecenas nec massa id nisi interdum lobortis. Donec tempus libero in magna tincidunt, in iaculis nisl vehicula. Proin vel odio dolor. Sed in gravida est. Mauris ut nibh eget arcu iaculis ultricies id ac ante. Integer dapibus, ipsum at pulvinar placerat, elit erat mattis lacus, ac tempus ipsum massa eget lectus. Maecenas commodo, nisi eu commodo cursus, elit magna congue tellus, sed pellentesque ligula dolor at quam. Ut id dui lacus. Suspendisse consequat est nec nibh vehicula, vel volutpat mauris accumsan.</tag-text>
  </div>
</tag-modal>`,
  },
  reactWrapper: {
    jsx: `<TagModal
  visible
  heading='Modal with fixed height'
  contentStyle={{overflow: "scroll", height:"200px"}}>
  <div>
    <TagText>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin volutpat aliquet venenatis. Sed faucibus maximus volutpat. Praesent fermentum porta urna, sed ornare justo facilisis eu. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Proin congue enim tortor, in aliquam ipsum hendrerit a. Suspendisse iaculis dui pellentesque ante accumsan posuere. Curabitur vulputate mollis libero quis ullamcorper. Maecenas nec massa id nisi interdum lobortis. Donec tempus libero in magna tincidunt, in iaculis nisl vehicula. Proin vel odio dolor. Sed in gravida est. Mauris ut nibh eget arcu iaculis ultricies id ac ante. Integer dapibus, ipsum at pulvinar placerat, elit erat mattis lacus, ac tempus ipsum massa eget lectus. Maecenas commodo, nisi eu commodo cursus, elit magna congue tellus, sed pellentesque ligula dolor at quam. Ut id dui lacus. Suspendisse consequat est nec nibh vehicula, vel volutpat mauris accumsan.</TagText>
    <TagText>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin volutpat aliquet venenatis. Sed faucibus maximus volutpat. Praesent fermentum porta urna, sed ornare justo facilisis eu. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Proin congue enim tortor, in aliquam ipsum hendrerit a. Suspendisse iaculis dui pellentesque ante accumsan posuere. Curabitur vulputate mollis libero quis ullamcorper. Maecenas nec massa id nisi interdum lobortis. Donec tempus libero in magna tincidunt, in iaculis nisl vehicula. Proin vel odio dolor. Sed in gravida est. Mauris ut nibh eget arcu iaculis ultricies id ac ante. Integer dapibus, ipsum at pulvinar placerat, elit erat mattis lacus, ac tempus ipsum massa eget lectus. Maecenas commodo, nisi eu commodo cursus, elit magna congue tellus, sed pellentesque ligula dolor at quam. Ut id dui lacus. Suspendisse consequat est nec nibh vehicula, vel volutpat mauris accumsan.</TagText>
    <TagText>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin volutpat aliquet venenatis. Sed faucibus maximus volutpat. Praesent fermentum porta urna, sed ornare justo facilisis eu. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Proin congue enim tortor, in aliquam ipsum hendrerit a. Suspendisse iaculis dui pellentesque ante accumsan posuere. Curabitur vulputate mollis libero quis ullamcorper. Maecenas nec massa id nisi interdum lobortis. Donec tempus libero in magna tincidunt, in iaculis nisl vehicula. Proin vel odio dolor. Sed in gravida est. Mauris ut nibh eget arcu iaculis ultricies id ac ante. Integer dapibus, ipsum at pulvinar placerat, elit erat mattis lacus, ac tempus ipsum massa eget lectus. Maecenas commodo, nisi eu commodo cursus, elit magna congue tellus, sed pellentesque ligula dolor at quam. Ut id dui lacus. Suspendisse consequat est nec nibh vehicula, vel volutpat mauris accumsan.</TagText>
    <TagText>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin volutpat aliquet venenatis. Sed faucibus maximus volutpat. Praesent fermentum porta urna, sed ornare justo facilisis eu. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Proin congue enim tortor, in aliquam ipsum hendrerit a. Suspendisse iaculis dui pellentesque ante accumsan posuere. Curabitur vulputate mollis libero quis ullamcorper. Maecenas nec massa id nisi interdum lobortis. Donec tempus libero in magna tincidunt, in iaculis nisl vehicula. Proin vel odio dolor. Sed in gravida est. Mauris ut nibh eget arcu iaculis ultricies id ac ante. Integer dapibus, ipsum at pulvinar placerat, elit erat mattis lacus, ac tempus ipsum massa eget lectus. Maecenas commodo, nisi eu commodo cursus, elit magna congue tellus, sed pellentesque ligula dolor at quam. Ut id dui lacus. Suspendisse consequat est nec nibh vehicula, vel volutpat mauris accumsan.</TagText>
    <TagText>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin volutpat aliquet venenatis. Sed faucibus maximus volutpat. Praesent fermentum porta urna, sed ornare justo facilisis eu. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Proin congue enim tortor, in aliquam ipsum hendrerit a. Suspendisse iaculis dui pellentesque ante accumsan posuere. Curabitur vulputate mollis libero quis ullamcorper. Maecenas nec massa id nisi interdum lobortis. Donec tempus libero in magna tincidunt, in iaculis nisl vehicula. Proin vel odio dolor. Sed in gravida est. Mauris ut nibh eget arcu iaculis ultricies id ac ante. Integer dapibus, ipsum at pulvinar placerat, elit erat mattis lacus, ac tempus ipsum massa eget lectus. Maecenas commodo, nisi eu commodo cursus, elit magna congue tellus, sed pellentesque ligula dolor at quam. Ut id dui lacus. Suspendisse consequat est nec nibh vehicula, vel volutpat mauris accumsan.</TagText>
  </div>
</TagModal>`,
  },
};

const headerlessStory: Story = {
  title: 'Headerless',
  description: 'A headerless tag-modal',
  coreComponent: {
    html: `<tag-modal
  visible
  container-style='{"background-color": "white"}'
  heading-container-style='{"background-color": "white", "border-bottom": "none"}'
  content-style='{"background-color": "white"}'>
    <div>This is a white modal with no header</div>
</tag-modal>`,
  },
  reactWrapper: {
    jsx: `<TagModal
  visible
  containerStyle={{backgroundColor: "white"}}
  headingContainerStyle={{backgroundColor: "white", borderBottom: "none"}}
  contentStyle={{backgroundColor: "white"}}
>
  <div>This is a white modal with no header</div>
</TagModal>`,
  },
};

const modalWithinModalStory: Story = {
  title: 'Modal within modal',
  description: 'A modal within modal',
  coreComponent: {
    html: `<tag-modal visible heading='Modal within modal - 1st modal'>
  <div>
    <tag-button text='Open 2nd modal'></tag-button>
  </div>
</tag-modal>
<tag-modal id='modal2' heading='Modal within modal - 2nd modal'>
</tag-modal>
`,
    js: `var btn = document.querySelector("tag-button[text='Open 2nd modal']");
btn.addEventListener('buttonClick', function() {
  var modal2 = document.querySelector('#modal2');
  modal2.show();
});`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [secondModalVisible, setSecondModalVisible] = React.useState(false);
    return (
      <React.Fragment>
        <TagModal
          visible
          heading="Modal within modal - 1st modal"
        >
          <div>
            <TagButton
              text="Open 2nd modal"
              onButtonClick={() => setSecondModalVisible(true)}
            />
          </div>
        </TagModal>
        <TagModal
          visible={secondModalVisible}
          heading="Modal within modal - 2nd modal"
        >
        </TagModal>
      </React.Fragment>
    )
  };`,
  },
};

export const TagModalDocs: Component = {
  type: 'component',
  name: 'modal',
  description: 'Renders a modal dialog',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'visible',
      description: 'Whether the dialog is shown',
      type: 'boolean',
    },
    {
      name: 'containerStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply to the outermost element',
    },
    {
      name: 'heading',
      type: 'string',
      description: 'The heading text',
    },
    {
      name: 'headingAccent',
      type: 'Accent',
      description: 'The heading colour',
      default: 'white',
    },
    {
      name: 'headerOption1',
      type: 'Icon',
      description: 'An icon that appears as header option 1',
    },
    {
      name: 'headerOption1Text',
      type: 'string',
      description: 'Text which appears with the header option 1',
    },
    {
      name: 'headerOption1Accent',
      type: 'Accent',
      description: 'The icon colour of header option 1',
    },
    {
      name: 'headerOption1RoundedBackground',
      type: 'boolean',
      description: 'Whether the option has a rounded background',
      default: 'white',
    },
    {
      name: 'headerOption1RoundedBackgroundAccent',
      type: 'boolean',
      description: 'The option rounded background colour',
      default: 'white',
    },
    {
      name: 'headerOption1Disabled',
      type: 'boolean',
      description: 'Whether the header option is disabled',
    },
    {
      name: 'headerOption2',
      type: 'Icon',
      description: 'An icon that appears as header option 2',
    },
    {
      name: 'headerOption2Text',
      type: 'string',
      description: 'Text which appears with the header option 2',
    },
    {
      name: 'headerOption2Accent',
      type: 'Accent',
      description: 'The icon colour of header option 2',
      default: 'white',
    },
    {
      name: 'headerOption2RoundedBackground',
      type: 'boolean',
      description: 'Whether the option has a rounded background',
      default: 'white',
    },
    {
      name: 'headerOption2RoundedBackgroundAccent',
      type: 'boolean',
      description: 'The option rounded background colour',
      default: 'white',
    },
    {
      name: 'headerOption2Disabled',
      type: 'boolean',
      description: 'Whether the header option is disabled',
    },

    {
      name: 'headerOption3',
      type: 'Icon',
      description: 'An icon that appears as header option 3',
    },
    {
      name: 'headerOption3Text',
      type: 'string',
      description: 'Text which appears with the header option 3',
    },
    {
      name: 'headerOption3Accent',
      type: 'Accent',
      description: 'The icon colour of header option 3',
    },
    {
      name: 'headerOption3RoundedBackground',
      type: 'boolean',
      description: 'Whether the option has a rounded background',
      default: 'white',
    },
    {
      name: 'headerOption3RoundedBackgroundAccent',
      type: 'boolean',
      description: 'The option rounded background colour',
      default: 'white',
    },
    {
      name: 'headerOption3Disabled',
      type: 'boolean',
      description: 'Whether the header option is disabled',
    },

    {
      name: 'headerOption4',
      type: 'Icon',
      description: 'An icon that appears as header option 4',
    },
    {
      name: 'headerOption4Text',
      type: 'string',
      description: 'Text which appears with the header option 4',
    },
    {
      name: 'headerOption4Accent',
      type: 'Accent',
      description: 'The icon colour of header option 4',
    },
    {
      name: 'headerOption4RoundedBackground',
      type: 'boolean',
      description: 'Whether the option has a rounded background',
      default: 'white',
    },
    {
      name: 'headerOption4RoundedBackgroundAccent',
      type: 'boolean',
      description: 'The option rounded background colour',
      default: 'white',
    },
    {
      name: 'headerOption4Disabled',
      type: 'boolean',
      description: 'Whether the header option is disabled',
    },

    {
      name: 'headerOption5',
      type: 'Icon',
      description: 'An icon that appears as header option 5',
    },
    {
      name: 'headerOption5Text',
      type: 'string',
      description: 'Text which appears with the header option 5',
    },
    {
      name: 'headerOption5Accent',
      type: 'Accent',
      description: 'The icon colour of header option 5',
    },
    {
      name: 'headerOption5RoundedBackground',
      type: 'boolean',
      description: 'Whether the option has a rounded background',
      default: 'white',
    },
    {
      name: 'headerOption5RoundedBackgroundAccent',
      type: 'boolean',
      description: 'The option rounded background colour',
      default: 'white',
    },
    {
      name: 'headerOption5Disabled',
      type: 'boolean',
      description: 'Whether the header option is disabled',
    },
    {
      name: 'headingStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply to the header',
    },
    {
      name: 'headingContainerStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply to the header container',
    },
    {
      name: 'contentStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply to the content slot',
    },
    {
      name: 'borderAccent',
      type: 'Accent',
      description: 'The border bottom colour',
      default: 'background',
    },
    {
      name: 'width',
      description: 'The width of the dialog',
      type: `'small' | 'medium' | 'large' | 'full-screen'`,
      default: 'medium',
    },
    {
      name: 'height',
      description: 'The height of the dialog',
      type: 'string',
    },
    {
      name: 'buttonContainerStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply to the button container',
    },
    {
      name: 'primaryButton',
      description:
        'The text for the primary button. If both this and the icon are blank, no primary button will be displayed',
      type: 'string',
    },
    {
      name: 'primaryButtonIcon',
      description: 'The icon for the primary button. Will be rendered even the text is blank',
      type: 'string',
    },
    {
      name: 'primaryButtonIconAccent',
      type: 'Accent',
      description: 'The icon colour of the primary button',
      default: 'white',
    },
    {
      name: 'primaryButtonAccent',
      type: 'Accent',
      description: 'The colour of the primary button',
      default: 'background',
    },
    {
      name: 'primaryButtonStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply to the button',
    },
    {
      name: 'cancelButton',
      description:
        'The text for the cancel button. If both this and the icon are blank, no cancel button will be displayed',
      type: 'string',
    },
    {
      name: 'cancelButtonIcon',
      description: 'The icon for the cancel button. Will be rendered even the text is blank',
      type: 'string',
    },
    {
      name: 'cancelButtonIconAccent',
      type: 'Accent',
      description: 'The icon colour of the cancel button',
      default: 'title',
    },
    {
      name: 'cancelButtonAccent',
      type: 'Accent',
      description: 'The colour of the cancel button',
      default: 'background',
    },
    {
      name: 'cancelButtonStyle',
      type: 'string',
      description: 'JSX style object in JSON to apply to the button',
    },
    {
      name: 'suppressCloseIcon',
      type: 'boolean',
      description: 'Whether the close button is suppressed ',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'opened',
      description: 'Raised when the dialog has opened',
      parameters: [],
    },
    {
      name: 'closed',
      description: 'Raised when the dialog closes',
      parameters: [],
    },
    {
      name: 'primaryButtonClick',
      description: 'Raised when the primary button is clicked',
      parameters: [
        {
          name: 'cancel',
          description: 'A boolean that allows the consumer to cancel the dialog being closed',
          type: 'boolean',
        },
      ],
    },
    {
      name: 'cancelButtonClick',
      description: 'Raised when the cancel button is clicked',
      parameters: [
        {
          name: 'cancel',
          description: 'A boolean that allows the consumer to cancel the dialog being closed',
          type: 'boolean',
        },
      ],
    },
    {
      name: 'headerOptionClick',
      description: 'Event raised when an option button is clicked',
      parameters: [
        {
          name: 'option',
          description: 'A number that tells you which option was clicked',
          type: 'number',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'show',
      description: 'Shows the modal dialog',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'hide',
      description: 'Hides the modal dialog',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [
    playgroundStory,
    buttonsStory,
    customButtonStylesStory,
    openCloseStory,
    roundedheaderOptionsStory,
    oldSchoolheaderOptionsStory,
    alertStory,
    focusStory,
    fixedHeightStory,
    headerlessStory,
    modalWithinModalStory,
  ],
};
